module.exports = __WEBPACK_EXTERNAL_MODULE__3027__;